export type OutgoKind =
  | 'rent'
  | 'food'
  | 'commodity'
  | 'hobby'
  | 'communication'
  | 'social'
  | 'utility'
  | 'other';

export type Outgo = {
  id: number;
  name: string;
  kind: OutgoKind;
  amount: number;
  registered_at: number;
};

export const convertNumberToOutgoKind = (num: number): OutgoKind => {
  switch (num) {
    case 0:
      return 'rent';
    case 1:
      return 'food';
    case 2:
      return 'commodity';
    case 3:
      return 'hobby';
    case 4:
      return 'communication';
    case 5:
      return 'social';
    case 6:
      return 'utility';
    default:
      return 'other';
  }
};

export const convertToOutgoKindDisplayString = (kind: OutgoKind): string => {
  switch (kind) {
    case 'rent':
      return '家賃';
    case 'food':
      return '食費';
    case 'commodity':
      return '日用品';
    case 'hobby':
      return '趣味';
    case 'communication':
      return '通信';
    case 'social':
      return '交際費';
    case 'utility':
      return '光熱費';
    case 'other':
      return 'その他';
    default:
      return 'その他';
  }
};

export type IncomeKind = 'salary' | 'other';

export const convertToIncomeKindDisplayString = (kind: IncomeKind): string => {
  switch (kind) {
    case 'salary':
      return '給料';
    case 'other':
      return 'その他';
    default:
      return 'その他';
  }
};

export type Income = {
  id: number;
  name: string;
  kind: IncomeKind;
  amount: number;
  registered_at: number;
};

export type MonthlyTotalAsset = {
  id: number;
  bank: number;
  wallet: number;
  year: number;
  month: number;
};

export type OutgoAggregateResult = {
  year: number;
  month: number;
  amount: number;
};

export type OutgoAggregateResultKind = OutgoKind | 'all';

export const convertToOutgoAggregateResultKindDisplayString = (
  kind: OutgoAggregateResultKind,
): string => {
  switch (kind) {
    case 'rent':
      return '家賃';
    case 'food':
      return '食費';
    case 'commodity':
      return '日用品';
    case 'hobby':
      return '趣味';
    case 'communication':
      return '通信';
    case 'social':
      return '交際費';
    case 'utility':
      return '光熱費';
    case 'other':
      return 'その他';
    default:
      return '全て';
  }
};

export type ImportedOutgoDetail = {
  id: number;
  name: string;
  kind: string;
  amount: number;
};

export type ImportedOutgo = {
  id: number | null;
  state: string;
  filepath: string | null;
  details: ImportedOutgoDetail[];
};

export type VehicleKind = 'normal_car' | 'motorcycle50' | 'other';

export const convertToVehicleKindDisplayString = (
  kind: VehicleKind,
): string => {
  switch (kind) {
    case 'normal_car':
      return '普通自動車';
    case 'motorcycle50':
      return '原付';
    default:
      return 'その他';
  }
};

export type Vehicle = {
  id: number;
  name: string;
  kind: VehicleKind;
  image: string | null;
  total_mileage: number;
  average_fuel_consumption: number;
  forecast_work_mileage: number;
  forecast_next_refuel_total_mileage: number;
};

export type RefuelHistory = {
  id: number;
  refuel_at: number;
  refuel_amount: number;
  mileage: number;
  fuel_consumption: number | null;
};

export type RefuelHistoryRequestParam = {
  id: number;
  refuel_at: number;
  refuel_amount: number;
  mileage: number;
  total_mileage: number;
  fuel_price: number;
};
